/**
 * AM.One API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * A discovered API specification file with raw source content.
 */
export interface ApiSpecificationDetailDto { 
    fileName: string;
    relativePath: string;
    type: ApiSpecificationDetailDto.TypeEnum;
    title?: string;
    version?: string;
    content: string;
    /**
     * The specification with references into sibling files inlined, as JSON. Absent when the specification references no other file. Clients receive only this one file, so a cross-file pointer would otherwise be a dead end for them. Note: a literal dollar sign here would break the Kotlin code generation, which emits descriptions into double-quoted strings without escaping them. 
     */
    resolvedContent?: string;
    /**
     * API files do not currently expose frontmatter creation metadata.
     */
    created?: string | null;
    lastEditedBy?: string | null;
    /**
     * API files do not currently expose frontmatter modification metadata.
     */
    lastModified?: string | null;
    commitTimestamp?: string | null;
}
export namespace ApiSpecificationDetailDto {
    export const TypeEnum = {
        OpenApi: 'OpenAPI',
        Swagger: 'Swagger',
        AsyncApi: 'AsyncAPI'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


